const defaultState = {
  listingUsers: []
};

export default defaultState;
